/**
 * Currency display: symbols and formatted price.
 * PLN shows "zł", others use standard symbols ($, €, £).
 */
export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  PLN: 'zł',
};

export const DISPLAY_CURRENCIES = ['PLN', 'USD', 'EUR', 'GBP'];

/** Catalog prices are stored in this currency. Artists cannot change it. */
export const CATALOG_CURRENCY = 'PLN';

export function normalizeDisplayCurrency(code) {
  const value = String(code || '').trim().toUpperCase();
  return DISPLAY_CURRENCIES.includes(value) ? value : 'PLN';
}

/** Converted browse price when the API returned one; otherwise the catalog price. */
export function resolveCatalogPrice(item, displayCurrency) {
  const preview = normalizeDisplayCurrency(displayCurrency);
  const nativeCurrency = String(item?.currency || 'PLN').toUpperCase();
  const nativeAmount = item?.price?.amount ?? item?.price;
  const convertedCurrency = item?.display_currency
    ? String(item.display_currency).toUpperCase()
    : '';
  const convertedAmount = item?.display_price;
  const hasConversion = convertedCurrency === preview
    && convertedAmount != null
    && convertedAmount !== ''
    && preview !== nativeCurrency;
  if (hasConversion) {
    return { amount: convertedAmount, currency: preview };
  }
  return { amount: nativeAmount, currency: nativeCurrency };
}

/**
 * Format amount with currency. For PLN uses "zł" (e.g. "9,99 zł"), for others standard symbol (e.g. "$9.99").
 * @param {number} amount
 * @param {string} currencyCode - PLN, USD, EUR, GBP
 * @param {string} [localeTag='pl-PL'] - passed to Intl.NumberFormat (separators/grouping)
 * @returns {string}
 */
export function formatPrice(amount, currencyCode = 'PLN', localeTag = 'pl-PL') {
  const code = (currencyCode || 'PLN').toUpperCase();
  const symbol = CURRENCY_SYMBOLS[code] ?? code;
  const num = Number(amount);
  if (Number.isNaN(num)) return '—';
  const formatted = new Intl.NumberFormat(localeTag, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
  if (code === 'PLN') {
    return `${formatted} ${symbol}`;
  }
  return `${symbol}${formatted}`;
}
